import milestones from './milestones';
import openProjects from './open-projects';
import closedProjects from './closed-projects';
import manualEntry, {_k_manualGrid} from './manual-entry';
import adjustPrevious from './adjust-previous';
import newMaintenance from './new-maintenance';
import fixedPriceWorkOrder from './fixed-price-wo';
import approvals from './approvals';
import finalizeBranch from './finalize-branch';
import {companyData} from '../../global/change-company';
import {updateSidebarTotals} from "./comission-totals";

const _company = companyData.id;
const _month = $('[name="Month"]').val();
const _year = $('[name="Year"]').val();
let _salespersonId = Number($('[name="Salesperson"]').val());
let _isBmOrServiceVp = false;
let _salespersonDropDownList;

export default function (namePage) {
    if (_salespersonId === 0) {
        _salespersonId = Number($('#SalespersonId').val());
    }

    if (namePage === 'ssrcommissionsfinalizebranch') {
        _isBmOrServiceVp = true;
        /*Finalize Branch Page*/
        approvals(_company, _month, _year, _salespersonId);
        finalizeBranch(_company, _month, _year, _salespersonId);

        updateSidebarTotals();

        setSalespersonDropdownList();
        updateSalespersonList();
        return;
    }

    if (namePage === 'ssrcommissions') {
        _isBmOrServiceVp = $('[name=IsBmOrServiceVp]').prop('checked');
        const menuItems = $('.menu-topbar__item');
        const overflow = menuItems.length - 6;
        if (overflow > 0) {
            if (overflow === 1) {
                menuItems.css('font-size', '77%');
            } else {
                const percentReduction = 100 - (17 * overflow);
                menuItems.css('font-size', `${percentReduction}%`);
            }
        }

        $('.menu-topbar__link').click(function () {
            loadTab(this);
        });
        setActiveTab();

        updateSidebarTotals();

        setSalespersonDropdownList();
        updateSalespersonList();
    }
}

function setActiveTab() {
    const urlHash = window.location.hash || '#Milestones';
    setTimeout(function () {
        $(`[href="${urlHash}"]`).click();
    }, 100);
}

function loadTab(ele) {
    const $activeTab = $(ele || '.menu-topbar__link.--active');
    const text = $activeTab.text();

    switch (text) {
        case 'Milestones' : {
            milestones(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Open Projects > $150k' : {
            openProjects(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Closed Projects' : {
            closedProjects(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Manual Entry' : {
            manualEntry(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Adjust Previous' : {
            adjustPrevious(_company, _month, _year, _salespersonId);
            break;
        }
        case 'New Maint. Agreements' : {
            newMaintenance(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Fixed Price WO' : {
            fixedPriceWorkOrder(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Approvals' : {
            approvals(_company, _month, _year, _salespersonId);
            break;
        }
        default :
            break;
    }
}

function updateSalespersonList() {
    const $monthDropdown = $('#MonthDisplay');

    if ($monthDropdown) {
        $monthDropdown.change(function () {
            if (_salespersonDropDownList) {
                _salespersonDropDownList.dataSource.read();
            }
        });
    }
}

function setSalespersonDropdownList() {
    _salespersonDropDownList = $('.js-salesperson-list').kendoDropDownList({
        dataTextField: 'Name', dataValueField: 'Value', dataSource: {
            transport: {
                read: {
                    url: '/Finance/GetSalespersonsList'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        const monthYear = $('#MonthDisplay').data('kendoDropDownList').value().split('/');
                        rs['company'] = _company;
                        rs['month'] = monthYear[0];
                        rs['year'] = monthYear[1];
                        rs['isBmOrServiceVp'] = _isBmOrServiceVp;
                        return rs;
                    }
                }
            }
        }
    }).data('kendoDropDownList');

    if (_salespersonDropDownList) {
        _salespersonDropDownList.value(_salespersonId);
        setTimeout(function () {
            $('.js-current-user').text(_salespersonDropDownList.text()).parent().show()
        }, 250)
    }
}